<template>
  <div>
    <div
      class="menu-item"
      v-for="(menu_item, m_index) in menu_items"
      :key="m_index"
      :class="isUrl(menu_item.url) ? ' active' : ''"
      v-on="menu_item.submenu ? { click: (e) => addActiveClass(e) } : {}"
    >
      <Link
        class="flex items-center group py-3 menu-link"
        :href="menu_item.route ? route(menu_item.route) : '#'"
        :class="{ 'have-sub-menu': menu_item.submenu }"
      >
        <icon :name="menu_item.icon" class="w-5 h-5 mr-3 rtl:ml-3 menu__icon" />
        <div class="menu__name">{{ __(menu_item.name) }}</div>
      </Link>
      <div v-if="menu_item.submenu" class="sub-menu-items">
        <Link
          class="sub-menu-item"
          v-for="(sub_menu_item, s_m_index) in menu_item.submenu"
          :key="s_m_index"
          :class="this.isUrl(sub_menu_item.url) ? ' active' : ''"
          :href="sub_menu_item.param ? route(sub_menu_item.route, sub_menu_item.param) : route(sub_menu_item.route)"
        >
          <icon
            v-if="sub_menu_item.icon"
            :name="sub_menu_item.icon"
            class="w-4 h-4 mr-1 rtl:ml-1 menu__icon"
          />
          <icon v-else name="dash" class="w-4 h-4 mr-1 rtl:mr-1 menu__icon" />
          <div class="menu__name">{{ __(sub_menu_item.name) }}</div>
        </Link>
      </div>
    </div>
  </div>
</template>

  <script>
import Icon from '@/Shared/Icon'
import { Link } from '@inertiajs/vue3'
// import { ref } from 'vue'

export default {
  components: {
    Icon,
    Link,
  },
  data() {
    return {
      user: null,
      menu_items: [],
      enable_option: {},
      menuVisibility: true,
    }
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      currentUrl = currentUrl.replace('dashboard/', '')
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
    addActiveClass(e) {
      e.currentTarget.classList.toggle('hover')
    },
  },

  async created() {
    this.user = this.$page.props.auth.user
    const user_access = this.user?.access || {}

    if (user_access.dashboard?.read) {
      this.menu_items.push({ name: 'Dashboard', route: 'dashboard', url: 'dashboard', icon: 'dashboard' })
    }

    if (user_access.ticket?.read) {
      this.menu_items.push({ name: 'Ticket', route: 'tickets', url: 'tickets', icon: 'ticket' })
    }

    if (user_access.chat?.read) {
      this.menu_items.push({ name: 'Chat', route: 'chat', url: 'chat', icon: 'chat' })
    }

    if (user_access.faq?.read) {
      this.menu_items.push({ name: 'FAQs', route: 'faqs', url: 'faqs', icon: 'faq' })
    }

    if (user_access.blog?.read) {
      this.menu_items.push({ name: 'Blog', route: 'posts', url: 'posts', icon: 'post' })
    }

    if (user_access.knowledge_base?.read) {
      this.menu_items.push({ name: 'Knowledge Base', route: 'knowledge_base', url: 'knowledge_base', icon: 'knowledge' })
    }

    if (user_access.customer?.read) {
      this.menu_items.push({ name: 'PIC', route: 'customers', url: 'customers', icon: 'all_users' })
    }

    if (user_access.notes?.read) {
      this.menu_items.push({ name: 'Notes', route: 'notes', url: 'notes', icon: 'notes' })
    }

    if (user_access.contact?.read) {
      this.menu_items.push({ name: 'Contacts', route: 'contacts', url: 'contacts', icon: 'contact' })
    }

    if (user_access.organization?.read) {
      this.menu_items.push({ name: 'Customer', route: 'organizations', url: 'organizations', icon: 'office' })
    }

    if (user_access.user?.read) {
      this.menu_items.push({ name: 'Manage Users', route: 'users', url: 'users', icon: 'users' })
    }

    if (user_access.technition?.read) {
      this.menu_items.push({ name: 'Technition Support', route: 'technition', url: 'technition', icon: 'pending_users' })
    }

    if (this.menuVisibility) {
      if (user_access.dashboard_asset_management?.read) {
        this.menu_items.push({ name: 'Dashboard Asset Management', route: 'asset_management.dashboard', url: 'board_asset_management', icon: 'dashboard' })
      }

      const assetManagementSubmenus = []

      if (user_access.asset_category?.read) {
        assetManagementSubmenus.push({ name: 'Category', route: 'asset_category', url: 'asset_management/asset_category', icon: 'page' })
      }

      if (user_access.asset_brand?.read) {
        assetManagementSubmenus.push({ name: 'Brand', route: 'asset_brand', url: 'asset_management/asset_brand', icon: 'page' })
      }

      if (user_access.asset_type?.read) {
        assetManagementSubmenus.push({ name: 'Type', route: 'asset_type', url: 'asset_management/asset_type', icon: 'page' })
      }

      if (user_access.asset?.read) {
        assetManagementSubmenus.push({ name: 'Stock Asset', route: 'assets', url: 'asset_management/assets', icon: 'page' })
      }

      if (user_access.outgoing_asset?.read) {
        assetManagementSubmenus.push({ name: 'Outgoing Asset', route: 'exit_goods', url: 'asset_management/exit_goods', icon: 'page' })
      }

      if (user_access.history_asset?.read) {
        assetManagementSubmenus.push({ name: 'History Asset', route: 'history_asset', url: 'asset_management/history_asset', icon: 'page' })
      }

      if (assetManagementSubmenus.length) {
        this.menu_items.push({
          name: 'Asset Management',
          route: '',
          url: 'asset_management',
          icon: 'departments',
          submenu: assetManagementSubmenus,
        })
      }
    }

    const settingSubmenus = []
    if (user_access.role_permission?.read) {
      settingSubmenus.push({ name: 'User Roles', route: 'roles', url: 'settings/roles', icon: 'user_role' })
    }

    if (user_access.global?.read) {
      settingSubmenus.push({ name: 'Global', route: 'global', url: 'settings/global', icon: 'global_setting' })
    }

    if (user_access.department?.read) {
      settingSubmenus.push({ name: 'Departments', route: 'departments', url: 'settings/departments', icon: 'departments' })
    }

    if (user_access.category?.read) {
      settingSubmenus.push({ name: 'Categories', route: 'categories', url: 'settings/categories', icon: 'category' })
    }

    if (user_access.status?.read) {
      settingSubmenus.push({ name: 'Status', route: 'statuses', url: 'settings/statuses', icon: 'status' })
    }

    if (user_access.priority?.read) {
      settingSubmenus.push({ name: 'Priorities', route: 'priorities', url: 'settings/priorities', icon: 'priorities' })
    }

    if (user_access.type?.read) {
      settingSubmenus.push({ name: 'Types', route: 'types', url: 'settings/types', icon: 'types' })
    }

    if (user_access.language?.read) {
      settingSubmenus.push({ name: 'Languages', route: 'languages', url: 'settings/languages', icon: 'edit' })
    }

    if (user_access.email_template?.read) {
      settingSubmenus.push({ name: 'Email Templates', route: 'templates', url: 'settings/templates', icon: 'email' })
    }

    if (user_access.smtp?.read) {
      settingSubmenus.push({ name: 'SMTP Mail', route: 'settings.smtp', url: 'settings/smtp', icon: 'email_template' })
    }

    if (user_access.pusher?.read) {
      settingSubmenus.push({ name: 'Pusher Chat', route: 'settings.pusher', url: 'settings/pusher', icon: 'chat' })
    }

    if (this.user.role.slug === 'admin') {
      settingSubmenus.push({ name: 'Email to ticket', route: 'settings.piping', url: 'settings/piping', icon: 'ticket' })
    }

    if (settingSubmenus.length) {
      this.menu_items.push({ name: 'Settings', route: '', url: 'settings', icon: 'settings', submenu: settingSubmenus })
    }

    if (user_access.front_page?.read) {
      this.menu_items.push({
        name: 'Front Pages',
        route: '',
        url: 'front_pages',
        icon: 'gear',
        submenu: [
          { name: 'Home', route: 'front_pages.page', url: 'front_pages/home', icon: 'page', param: 'home' },
          { name: 'Contact', route: 'front_pages.page', url: 'front_pages/contact', icon: 'page', param: 'contact' },
          { name: 'Services', route: 'front_pages.page', url: 'front_pages/services', icon: 'page', param: 'services' },
          { name: 'Privacy Policy', route: 'front_pages.page', url: 'front_pages/privacy', icon: 'page', param: 'privacy' },
          { name: 'Terms of services', route: 'front_pages.page', url: 'front_pages/terms', icon: 'page', param: 'terms' },
          { name: 'Footer', route: 'front_pages.page', url: 'front_pages/footer', icon: 'page', param: 'footer' },
        ],
      })
    }
  },
  // if (this.user.role.slug === 'admin') {
  //   this.menu_items.push({ name: 'System Update', route: 'settings.update', url: 'settings/update', icon: 'archive' })
  // }
}
</script>
